/**
 * Formatea un número con separadores de miles (punto) y decimales (coma)
 * Ejemplo: 1234.56 -> "1.234,56"
 */
export const formatNumber = (value: number | null | undefined, decimals: number = 2): string => {
  if (value == null || isNaN(value)) return '0'
  return Number(value).toLocaleString('es-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
}

/**
 * Formatea un precio en formato moneda
 * Ejemplo: 1234.56 -> "$1.234,56"
 */
export const formatPrice = (value: number | null | undefined, decimals: number = 2): string => {
  return `$${formatNumber(value, decimals)}`
}

/**
 * Formatea un porcentaje
 * Ejemplo: 12.34 -> "12,34%"
 */
export const formatPercentage = (value: number | null | undefined, decimals: number = 2): string => {
  return `${formatNumber(value, decimals)}%`
}

/**
 * Formatea un número de cantidad con más decimales
 * Ejemplo: 0.123456 -> "0,123456"
 */
export const formatAmount = (value: number | null | undefined, decimals: number = 6): string => {
  return formatNumber(value, decimals)
}
